import { PublicRequestSuccessView } from "@/Components/PublicRequest/PublicRequestSuccessView";
import { usePublicRequestProvider } from "@/Provider/PublicRequestProvider";
import { publicRequestContentSx } from "@/Utils/MagicLink/pageLayout";
import { Box } from "@mui/material";

export const PublicRequestSuccessContent = () => {
    const { getRecaptchaCode, publicRequestResult } = usePublicRequestProvider();

    if (!publicRequestResult) {
        return null;
    }

    return (
        <Box component="main" sx={publicRequestContentSx}>
            <PublicRequestSuccessView
                getRecaptchaCode={getRecaptchaCode}
                publicRequestResult={publicRequestResult}
            />
        </Box>
    );
};
